<div>
    <div class="mr-1">Unit Price: {{ item.price | currency : currencyCode + " " }}</div>
    <form
        name="item-quantity-form"
        [formGroup]="quantityInput"
    >
        <label class="mr-1">Quantity: </label>
        <input
            type="number"
            name="quantity"
            formControlName="quantity"
            min="1"
            max="{{item.maxQuantity}}"
        />
    </form>
</div>
